var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "price",
    class: _vm.containerCss
  }, [_vm._v("\n  " + _vm._s(_vm.$n(_vm.value, 'currency')) + "\n")])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85457644","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Price.vue
// module id = 2077
// module chunks = 0